import { is_empty } from "utils/validations";

export const getTagsDropdownOptions = (tags) => {
  if (is_empty(tags)) return [];

  return tags.map(({ name: label, uuid: value }) => ({ label, value }));
};
